let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7zFV7")).then(() => parcelRequire('g6aPf'));